<script setup lang="ts">
import { computed, onMounted } from 'vue';
import { GpxMetersDistanceField } from '@gpx-spa/ui';
import {
  COMPOSER_STOP_RADIUS_MAX_M,
  COMPOSER_STOP_RADIUS_MIN_M,
  COMPOSER_STOP_RADIUS_STEP_M,
  migrateFormLocalStorageKey,
  SHIPMENT_COMPOSER_STOP_RADIUS_RECENT_KEY,
  SHIPMENT_COMPOSER_STOP_RADIUS_RECENT_KEY_LEGACY,
} from '@/components/shipment/form/domain/constants';
import type { ShipmentFormStopRow } from '@/stores/useShipmentFormStore';
import { useShipmentFormStore } from '@/stores/useShipmentFormStore';
import type { ShipmentFormStopFieldErrors } from '@/components/shipment/form/utils/shipment-form-stop-validation';

const props = defineProps<{
  stop: ShipmentFormStopRow;
  fieldErrors?: ShipmentFormStopFieldErrors;
  radiusDisabled: boolean;
}>();

const store = useShipmentFormStore();

const radiusM = computed({
  get: () => props.stop.radiusM,
  set: (v: number) => store.setStopRadius(props.stop.key, v),
});

onMounted(() => {
  migrateFormLocalStorageKey(
    SHIPMENT_COMPOSER_STOP_RADIUS_RECENT_KEY,
    SHIPMENT_COMPOSER_STOP_RADIUS_RECENT_KEY_LEGACY,
  );
});
</script>

<template>
  <GpxMetersDistanceField
    v-model="radiusM"
    title="Address radius"
    :min-meters="COMPOSER_STOP_RADIUS_MIN_M"
    :max-meters="COMPOSER_STOP_RADIUS_MAX_M"
    :step-meters="COMPOSER_STOP_RADIUS_STEP_M"
    size="small"
    :invalid="Boolean(fieldErrors?.location)"
    :storage-key="SHIPMENT_COMPOSER_STOP_RADIUS_RECENT_KEY"
    recent-label="Recent"
    :disabled="radiusDisabled"
  />
</template>
